export default "__VITE_ASSET__Cai8iCJK__"